import { useState, useEffect } from "react";

const useUserRoles = () => {
  const [userRoles, setUserRoles] = useState([]);

  useEffect(() => {
    const userClaims = JSON.parse(localStorage.getItem("user-claims"));
    if (userClaims && userClaims.roles) {
      setUserRoles(userClaims.roles);
    }
  }, []);

  const hasRole = (roleName) => userRoles.some((data) => data.name === roleName);

  return {
    otherServicesRole: hasRole("practitioner"),
    adminRole: hasRole("admin"),
    clinicalManagerRole: hasRole("clinical-manager"),
    facilityManagerRole: hasRole("facility-manager"),
    careHomeManagerRole: hasRole("carehome-manager"),
    customerSupportRole: hasRole("customer-support"),
  };
};

export default useUserRoles;